import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=194a0d8c&"
import script from "./apps.ts?vue&type=script&lang=ts&"
export * from "./apps.ts?vue&type=script&lang=ts&"
import style0 from "./apps.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports